<template>
  <div>
    <v-text-field
      :label="label"
      @input="changeInput"
      :value="codeValue ? value.code : value.desc"
      :clearable="!disableLookup"
      @click:clear="clear"
      :class="classPadding"
      readonly
      :dense="dense"
    >
      <template slot="append">
        <v-icon @click.stop="search" v-if="!disableLookup">mdi-magnify</v-icon>
        <span class="required" v-if="required">*</span>
      </template>
    </v-text-field>
    <v-dialog v-model="dialog" width="700">
      <v-card>
        <v-card-title>
          <span class="headline">{{title}}</span>
        </v-card-title>
        <v-card-text>
          <list :param="param">
            <template slot="actions" slot-scope="{item}">
              <v-btn @click.stop="select(item)" text outlined>Select</v-btn>
            </template>
          </list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="dialog = false" text>CLose</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./Pagination";
export default {
  props: [
    "value",
    "classPadding",
    "label",
    "title",
    "codeValue",
    "required",
    "dense",
    "disableLookup",
    "param"
  ],
  components: {
    List
  },
  data: () => ({
    dialog: false,
    selectedCode: null,
    selectedDesc: null,
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "pagibigCode",
        sortable: true
      },
      {
        text: "Description",
        value: "pagibigDesc",
        sortable: true
      }
    ]
  }),
  methods: {
    search() {
      this.dialog = true;
    },
    select(item) {
      this.selectedCode = item.empStatCode;
      this.selectedDesc = item.empStatDesc;
      this.changeInput();
      this.dialog = false;
    },
    clear() {
      this.selectedCode = null;
      this.selectedDesc = null;
      this.model = {};
    },
    changeInput() {
      this.$emit("input", {
        code: this.selectedCode,
        desc: this.selectedDesc
      });
    },
    setItem(value) {
      this.selectedCode = value.code;
      this.selectedDesc = value.desc;
    }
  },
  mounted() {
    this.setItem(Object.assign(this.value, {}));
  }
};
</script>